export const AD_CATEGORY_ATTEMPT = "AD_CATEGORY_ATTEMPT";
export const AD_CATEGORY_SUCCESS = "AD_CATEGORY_SUCCESS";
export const AD_CATEGORY_FAILED = "AD_CATEGORY_FAILED";
export const LOGOUT = "LOGOUT";